export enum RoleplayPageType {
  RoleplayDetail = "roleplayDetail",
  ScenarioDetail = "scenarioDetail",
  SessionDetail = "sessionDetail",
  ScenarioCreate = "scenarioCreate",
  IntakeProcessing = "intakeProcessing",
  ScenarioEdit = "scenarioEdit",
}
